import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { FaSpinner, FaLink } from 'react-icons/fa';

const formatarCpf = (cpf) => {
  if (!cpf) return '';
  const so = String(cpf).replace(/\D/g, '');
  if (so.length !== 11) return cpf;
  return `${so.substr(0, 3)}.${so.substr(3, 3)}.${so.substr(6, 3)}-${so.substr(9, 2)}`;
};

const formatarTelefone = (tel) => {
  if (!tel) return '';
  const d = String(tel).replace(/\D/g, '');
  if (d.length === 11) {
    return `(${d.substr(0, 2)}) ${d.substr(2, 5)}-${d.substr(7, 4)}`;
  }
  if (d.length === 10) {
    return `(${d.substr(0, 2)}) ${d.substr(2, 4)}-${d.substr(6, 4)}`;
  }
  return tel;
};

const touchStyle = {
  minHeight: 44,
  fontSize: '1rem',
};

// Prospecto do CRM fora do evento. "Vincular interesse" liga o prospecto ao
// empreendimento do evento e já dá entrada (vira um confirmado).
const CardProspecto = ({ prospecto, vinculando, onVincular }) => (
  <Card className="mb-3" style={{ borderLeft: '4px solid #4263eb' }}>
    <Card.Body className="p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '1.05rem' }}>
            {prospecto.nome}{' '}
            <Badge variant="primary" style={{ fontSize: '0.7rem', verticalAlign: 'middle' }}>
              Prospecto
            </Badge>
          </div>
          <div className="text-muted" style={{ fontSize: '0.85rem' }}>
            {prospecto.cpf ? `CPF ${formatarCpf(prospecto.cpf)}` : 'Sem CPF'}
            {prospecto.telefone ? ` · ${formatarTelefone(prospecto.telefone)}` : ''}
          </div>
          <div className="text-muted" style={{ fontSize: '0.8rem' }}>
            Código {prospecto.codigo_prospecto} · ainda não está no evento
          </div>
        </div>
        <Button
          variant="primary"
          onClick={() => onVincular(prospecto.codigo_prospecto)}
          disabled={vinculando}
          style={{ ...touchStyle, fontWeight: 600 }}
        >
          {vinculando ? (
            <FaSpinner className="fa-spin" />
          ) : (
            <>
              <FaLink className="mr-1" /> Vincular + entrada
            </>
          )}
        </Button>
      </div>
    </Card.Body>
  </Card>
);

export default CardProspecto;
